<template>
  <div class="MarketInterpretation">
    <div v-if="swidth > 768" class="mki-border">
      <div v-for="(content, index) in marketHeaderContent" :key="index" class="flex mt-40">
        <div class="left flex justify-center items-center">
          <div>
            <div class="flex items-end">
              <AniNumber class="number fl-l" :class="{ add: content.left.add }" :num="content.left.number">
              </AniNumber>
              <span class="sub">{{ $t("solution.m1") }}</span>
            </div>
            <div class="words fw-n text-center">{{ content.left.words }}</div>
          </div>
        </div>
        <div class="right flex  justify-evenly w-75">
          <div class="right-content w-3333" v-for="item in content.right" :key="item.id">
            <div class="flex items-end justify-center ">
              <template v-if="content.type === 'nums'">
                <AniNumber class="number fl-l" :num="item.number">
                </AniNumber>
                <span class="sub">{{ $t("solution.m2") }}</span>
              </template>
              <template v-if="content.type === 'pics'">
                <img class="mt-10" :width="item.width" :height="item.height" :src="item.pic" alt="item.title" />
              </template>
            </div>
            <div class="words fw-n mt-10 text-center" v-html="item.words"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between " v-else>
      <div style="width: 40%;">
        <div class="text-left m-auto">
          <AniNumber class="number fl-l" :class="{ add: marketHeaderContent[1].left.add }"
            :num="marketHeaderContent[1].left.number">
          </AniNumber>
          <span class="sub">{{ $t("solution.m1") }}</span>
        </div>
        <div class="words fw-n text-left">{{ marketHeaderContent[1].left.words }}</div>
        <div class="line text-left"></div>
        <ul>
          <li v-for="(item, index) in marketHeaderContent[1].right" :key="index" class="mt-20">
            <div>
              <template v-if="marketHeaderContent[1].type === 'nums'">
                <AniNumber class="number fl-l" :num="item.number">
                </AniNumber>
                <span class="sub">{{ $t("solution.m2") }}</span>
              </template>
              <template v-if="marketHeaderContent[1].type === 'pics'">
                <img :width="item.width2" :height="item.height2" :src="item.pic" :alt="item.title" />
              </template>
            </div>
            <div class="words fw-n mt-20 text-left" v-html="item.words"></div>
          </li>
        </ul>
      </div>
      <div class="divider"></div>
      <div style="width: 40%;">
        <div class="text-left m-auto">
          <AniNumber class="number fl-l" :class="{ add: marketHeaderContent[0].left.add }"
            :num="marketHeaderContent[0].left.number">
          </AniNumber>
          <span class="sub">{{ $t("solution.m1") }}</span>
        </div>
        <div class="words fw-n text-left">{{ marketHeaderContent[0].left.words }}</div>
        <div class="line text-left"></div>
        <ul>
          <li v-for="(item, index) in marketHeaderContent[0].right" :key="index" class="mt-20">
            <div>
              <template v-if="marketHeaderContent[0].type === 'nums'">
                <AniNumber class="number fl-l" :num="item.number">
                </AniNumber>
                <span class="sub">{{ $t("solution.m2") }}</span>
              </template>
              <template v-if="marketHeaderContent[0].type === 'pics'">
                <img :width="item.width" :height="item.height" :src="item.pic" :alt="item.title" />
              </template>
            </div>
            <div class="words fw-n mt-20 text-left" v-html="item.words"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AniNumber from "./AniNumber.vue";
export default {
  name: "MarketInterpretation",
  data() {
    return {
      // 市场解读的数组列表
      marketHeaderContent: [
        {
          left: { number: 2860, words: this.$t("solution.m3") },
          right: [
            {
              number: 168,
              words: this.$t("solution.m4"),
            },
            {
              number: 219,
              words: this.$t("solution.m5"),
            },
            {
              number: 2052,
              words: this.$t("solution.m6"),
            },
          ],
          type: "nums",
        },
        {
          left: { number: 600, add: true, words: this.$t("solution.m7") },
          right: [
            {
              pic: require("../assets/images/s-icon1.png"),
              width: 60,
              height: 60,
              width2: 46,
              height2: 46,
              words: this.$t("solution.m8"),
            },
            {
              pic: require("../assets/images/s-icon2.png"),
              width: 60,
              height: 60,
              width2: 46,
              height2: 46,
              words: this.$t("solution.m9"),
            },
            {
              pic: require("../assets/images/s-icon3.png"),
              width: 60,
              height: 60,
              width2: 46,
              height2: 46,
              words: this.$t("solution.m10"),
            },
          ],
          type: "pics",
        },
      ],
    };
  },
  props: {
    swidth: {
      type: Number
    }
  },
  components: {
    AniNumber,
  },
};
</script>

<style lang="less" scoped>
.mt-10 {
  margin-top: 10px;
}

.MarketInterpretation {
  padding: 20px 0 50px;
}

.mki-border {
  border-bottom: 1px solid @border-bold-color;
  padding-bottom: 20px;
}

.left {
  width: 25%;
  min-width: 160px;
  border-right: 1px solid @border-bold-color;

  .words {
    font-size: 25px;
    color: @text-title-ZH-color;
  }
}

.number {
  font-size: 49px;
  color: @primaryColor;
  font-weight: 600 !important;
}

.add {
  &::after {
    font-size: 51px;
    content: "+ ";
  }
}

.sub {
  font-size: 20px;
  color: @primaryColor;
  margin-bottom: 10px;
}

.right {
  &-content {
    // min-width: 126px;
    // margin-left: 172px;
  }

  .words {
    font-size: 16px;
    color: @text-title-ZH-color;
  }
}

.line {
  width: 70px;
  height: 1px;
  background: #8d8d8d;
  margin: 25px 0;
}

.divider {
  width: 1px;
  // height: 100%;
  background: #cecece;
  // margin: 90px 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/MarketInterpretation.vue